import React, {useState} from "react";
import {useNominalCodesData} from "../../../hooks/useNominalCodesData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getNominalCodesData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import {Box, Columns, Heading, Pagination, Table} from "react-bulma-components";
import NominalCodeRow from "./NominalCodeRow";
import {createSetDataFreshAction, createSetNominalCodesDataAction} from "../../../actions/dataActions";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import NewNominalCode from "./NewNominalCode";
import Collapsible from "react-collapsible";
import {formatXeroData, sendXeroData} from "../../../utils";



export default function NominalCodeView(props){
    const dispatch = useDispatch();
    const dataFresh = useSelector(getDataFresh);
    const [page, setPage] = useState(1);
    let loading = useNominalCodesData({page}, dataFresh);
    const data = useSelector(getNominalCodesData);


    const onChange = (e, index) => {
        let newCodes = {...data};
        newCodes.results[index][e.target.name] = e.target.value;
        dispatch(createSetNominalCodesDataAction(newCodes));
    };

    const validator = data => {
        if(data.code){
            return true;
        }
        return false;
    };

    const onSave = data => {
        if(validator(data)){
            let url = data.id ? "nominal/"+data.id : "nominal";
            const conf = {
                url: props.endpoint+url,
                method: data.id ? "put" : "post",
                data: data
            }
            axios(conf).then(res => {
                dispatch(createSetDataFreshAction(dataFresh+1));
                let code = formatXeroData(res.data, "NC");
                console.log(code);
                sendXeroData(code, "XeroNominal").then(res => {
                    NotificationManager.success("All Data has been sent to xero sucessfully")
                }).catch(err => {
                    console.log(err);
                    NotificationManager.error("There was an error sending data to Xero")
                })
            }).catch(err => {
                NotificationManager.error("There was an error saving nominal code");
            })
        }
        else{
            NotificationManager.warning("Code Required");
        }
    };

    const onDelete = (data) => {
        const conf = {
            url: props.endpoint + "nominal/" + data.id,
            method: "delete"
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1))
        }).catch(err => {
           NotificationManager.error("Error when deleting nominal code");
        })
    };


    if(!loading){
        return (
            <LoadingSpinner/>
        )
    }



    return (
        <div>
            <br/>
            <NewNominalCode onSave={onSave}/>
            <Box>
                <Collapsible
                    trigger={"Nominal Codes"}
                    triggerOpenedClassName={"title"}
                    className={"title"}
                >
                    <Columns>
                        <Columns.Column>
                            <Table size={"fullwidth"}>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Type</th>
                                        <th>Tax Type</th>
                                        <th>Bank Account Number</th>
                                        <th>Description</th>
                                        <th>Enable Payments to Account</th>
                                        <th>Show in Expense Claims</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((data, index) => (
                                    <NominalCodeRow
                                        code={data}
                                        onSave={onSave}
                                        onDelete={onDelete}
                                        onChange={onChange}
                                        index={index}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                    <Pagination
                        showFirstLast={true}
                        onChange={page => setPage(page)}
                        current={page}
                        total={Math.ceil(data.count / 25)}
                    />
                </Collapsible>
            </Box>
        </div>
    )



}